var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    enableBackground: "new 0 0 31 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#178FEB",
    d: "M17.2,4C11,4,6,9,6,15.2v4.8l-3.9-4L0,18.2L7.6,26l7.4-7.9L12.8,16L9,20.1v-4.8C9,10.7,12.7,7,17.2,7 s8.2,3.7,8.2,8.2s-3.7,8.2-8.3,8.2H17v3h0.2c6.3,0,11.3-5,11.3-11.2S23.5,4,17.2,4z M7.5,21.7l-0.2-0.2h0.3L7.5,21.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/rotate-left.8b98aeeb53c75decaf71bb5ef2f1402c.svg";
export { ForwardRef as ReactComponent };